import React from 'react'

const ToasterContext = React.createContext()

export default ToasterContext
